export default __webpack_public_path__ + "static/media/Nederland.5de3f0eb.svg";